
import { defineComponent, PropType } from 'vue'
import { Block } from '~/domain/interfaces/BlockTypes'
import router from 'vue-router'

export default defineComponent({
  name: 'GlossaryChapter',
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
    isFirstItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      firstLetter: '',
      url: this.block.diagramLink,
      fuid: this.block.diagramFuid,
      thumbnailUrl: this.block.diagramThumbnailUrl,
      showReadMore: false,
      listView: false,
      loading: true,
      isExpanded: false,
      isInitiallyExpanded: false,
      readMoreIsLoading: false,
    }
  },
  created() {
    this.isInitiallyExpanded = this.isFirstItem
  },
  computed: {
    showContent() {
      return this.isInitiallyExpanded || this.isExpanded
    },
  },
  watch: {
    showContent(newVal) {
      if (newVal) {
        this.checkTextEllipsis()
      }
    },
    isFirstItem(newVal) {
      this.isInitiallyExpanded = newVal
    },
    $route() {
      if (this.readMoreIsLoading) {
        this.readMoreIsLoading = false
      }
    },
  },
  mounted() {
    this.chapterFirstLetter()
  },
  methods: {
    toggleExpansion() {
      if (this.isInitiallyExpanded || this.isExpanded) {
        this.isInitiallyExpanded = false
        this.isExpanded = false
      } else {
        this.isExpanded = true
      }
    },
    slugifyChapter(chapterTitle: any) {
      return chapterTitle
        .trim()
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
    },
    chapterFirstLetter() {
      const titleTextElement = this.$refs.chapterText as HTMLElement

      if (titleTextElement && titleTextElement.textContent) {
        const content = titleTextElement.textContent.trim()

        if (content.length > 0) {
          this.firstLetter = content[0].toUpperCase()
        }
      }
    },
    openNewTab(url: string) {
      window.open(url, '_blank')
    },
    checkTextEllipsis() {
      this.$nextTick(() => {
        const textElement = this.$refs.text as HTMLElement
        this.showReadMore =
          textElement?.scrollHeight > textElement?.clientHeight
      })
    },
    handleReadMore() {
      this.readMoreIsLoading = true
    },
  },
})
